import { useState } from "react";
import { Badge } from "../../../components/Badge";
import { Chip } from "../../../components/Chip";
import { Section } from "../DesignSystem";

const row: React.CSSProperties = {
  display: "flex",
  gap: "var(--space-3)",
  flexWrap: "wrap",
  marginBottom: "var(--space-4)",
};

export const ChipsBadgesSection = () => {
  const [selected, setSelected] = useState("all");
  const filters = [
    { id: "all", label: "All", count: 14 },
    { id: "tills", label: "Cash tills", count: 3 },
    { id: "entr", label: "Entrances", count: 2 },
    { id: "stor", label: "Storage", count: 4 },
    { id: "dine", label: "Dining", count: 5 },
  ];
  return (
    <Section label="08 · Components" title="Chips & Badges">
      <div style={row}>
        {filters.map((f) => (
          <Chip
            key={f.id}
            count={f.count}
            selected={selected === f.id}
            onClick={() => setSelected(f.id)}
          >
            {f.label}
          </Chip>
        ))}
      </div>
      <div style={row}>
        <Badge variant="accent">Owner</Badge>
        <Badge variant="warn">Admin</Badge>
        <Badge variant="neutral">Viewer</Badge>
        <Badge variant="accent">LIVE · main stream</Badge>
        <Badge variant="success">Operator</Badge>
      </div>
    </Section>
  );
};
